// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header__search .ant-input-affix-wrapper>input{border-top-left-radius:10px!important;border-bottom-left-radius:10px!important;font-size:15px!important}.header__search .ant-input-affix-wrapper .ant-input:not(:last-child){padding-right:50px}.header__search .ant-input-affix-wrapper .ant-input-suffix{right:0;padding-right:10px}.header__search .ant-input-group-addon .search-btn .anticon-loading svg{width:14px;height:38px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
